import {gql} from '@apollo/client'
export const queryAndroidAppScore=gql`
query AndroidAppScore($app: String!) {
  androidAppScore(app: $app) {
    data {
      date
      score
    }
    latestAt
    latestScore
    total
  }
}
`
export const queryIosAppScore=gql`
query IosAppScore($app: String!) {
  iosAppScore(app: $app) {
    data {
      date
      score
    }
    latestAt
    latestScore
    total
  }
}
`
export const queryAppVersionList=gql`
query Query($app: String!) {
  appVersionList(app: $app)
}
`
export const queryAppReviewsList=gql`
query AppReviewsList($app: String!, $page: Int!, $count: Int!, $version: String, $startDate: Date, $endDate: Date, $platform: AppPlatform, $ignore: Boolean) {
  appReviewsList(app: $app, page: $page, count: $count, version: $version, startDate: $startDate, endDate: $endDate, platform: $platform,ignore: $ignore) {
    data {
      appVersion
      content
      createdAt
      region
      replyDate
      replyText
      score
      title
      userName
      id
      jiraId
      status
    }
    total
  }
}
`
export const queryZendeskProjectConfig = gql`
query Query {
  zendeskProjectConfig {
    issueType {
       display
      id
    }
    projectId
    projectName
  }
}
`
export const syncReveiwToJira = gql`
mutation SyncReveiwToJira($syncReveiwToJiraId: String!, $platform: AppPlatform!, $projectId: Int!, $issueType: Int!,$assignTo:String!) {
  syncReveiwToJira(id: $syncReveiwToJiraId, platform: $platform, projectId: $projectId, issueType: $issueType,assignTo:$assignTo) {
    jiraId
    link
  }
}
`
export const UpdateReviewStatus = gql`
mutation UpdateReviewStatus($updateReviewStatusId: String!, $status: TicketStatus!, $platform: AppPlatform!) {
  updateReviewStatus(id: $updateReviewStatusId, status: $status, platform: $platform) {
    id
    jiraId
    status
  }
}
`
export const queryJiraMembers = gql`
query JiraMembers {
  jiraMembers {
    accountId
    email
    name
  }
}`